import React from "react";
import { Navigate } from "react-router-dom";

export default function RequireRole({ allow, children }) {
  const userTeam = sessionStorage.getItem("Team");
  const allowed = Array.isArray(allow) ? allow : [allow];

  if (!userTeam || !allowed.includes(userTeam)) {
    return <Navigate to="/policies" replace />;
  }

  return children;
}
